import { IsoBa, WholesaleMarketDatasetWithFilesSimple } from '@/interfaces'

export const useIsSpainDataset = (
  datasetInfo?: WholesaleMarketDatasetWithFilesSimple
) => datasetInfo?.isoBaItems?.includes(IsoBa.ES_PENINSULA)
